// @ts-nocheck
/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { init as initApm } from '@elastic/apm-rum';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { Slide, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './state/store/Store';
import reportWebVitals from './reportWebVitals';
import App from './App';
import packageJson from '../package.json';
import { loadFont } from './utils/fontLoader';

const notistackRef = React.createRef();
const onClickDismiss = (key) => () => {
  notistackRef.current.closeSnackbar(key);
};

// ─── Config validation ───────────────────────────────────────────────────────
// Every key that window.CONFIG MUST contain for the app to function.
// If any key is missing, we halt with a clear error message.
const REQUIRED_CONFIG_KEYS = [
  'REACT_APP_ENV',
  'REACT_APP_SAMS_BASE_URL',
  'REACT_APP_FAST_API_BASE_URL',
  'REACT_APP_KEYCLOACK_URL',
  'REACT_APP_KEYCLOAK_LOGIN',
  'REACT_APP_ERROR_LOGGER',
  'REACT_APP_KIBANA_URL',
];

const missingKeys = REQUIRED_CONFIG_KEYS.filter(
  (key) => window.CONFIG?.[key] === undefined
);

if (missingKeys.length > 0) {
  document.getElementById('root').innerHTML = `
    <div style="padding:40px;font-family:monospace;color:#c00;background:#fff;border:2px solid #c00;margin:40px;border-radius:8px">
      <h2 style="margin-bottom:12px">⚠️ Configuration Error</h2>
      <p style="margin-bottom:8px">The following required keys are missing from <code>window.CONFIG</code>:</p>
      <ul style="margin-left:20px">${missingKeys.map(k => `<li>${k}</li>`).join('')}</ul>
      <p style="margin-top:12px">Check that the correct <code>env.js</code> file was deployed for environment: 
        <strong>${window.CONFIG?.REACT_APP_ENV || 'unknown'}</strong></p>
    </div>
  `;
  throw new Error(`SAMS: Missing config keys: ${missingKeys.join(', ')}`);
}
// ─────────────────────────────────────────────────────────────────────────────

try {
  // eslint-disable-next-line no-unused-vars
  const apm = initApm({
    serviceName: `${packageJson.name}-${window.CONFIG.REACT_APP_ENV}`,

    serverUrl: `${window.CONFIG.REACT_APP_ERROR_LOGGER}`,

    // Set service version (required for sourcemap feature)
    serviceVersion: packageJson.version,
    environment: window.CONFIG.REACT_APP_ENV,
    active: window.CONFIG.NODE_ENV === 'production',
    distributedTracingOrigins: window.location.pathname,
    logLevel: 'warn',
  });
  window.apm = apm;
} catch (e) {
  // eslint-disable-next-line no-console
  console.log('Failed to start APM RUM Agent', e);
}

/**
 * Render the app
 */
const renderApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <SnackbarProvider
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            TransitionComponent={Slide}
            hideIconVariant={false}
            ref={notistackRef}
            action={(key) => (
              <IconButton
                aria-label="close"
                size="small"
                onClick={onClickDismiss(key)}
              >
                <CloseIcon style={{ fill: '#FFFFFF' }} color="secondary" />
              </IconButton>
            )}
          >
            <App notistackRef={notistackRef} />
          </SnackbarProvider>
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );

  reportWebVitals();
};

// Load fonts, then render app
loadFont(renderApp);
